import { ClassKey } from "@const/class.constants";

export const LPAR = [ClassKey.VIRTUALIZATION, ClassKey.DATABASE, ClassKey.CONTAINER, ClassKey.CLOUD, ClassKey.BACKUP, ClassKey.SERVERSP, ClassKey.TAPE] as const;
export const STOR = [ClassKey.STORAGE, ClassKey.SAN, ClassKey.LAN] as const;

export type ClassType = typeof ClassKey[keyof typeof ClassKey];

export function isClassLPAR(cls: string) {
  return (LPAR as readonly string[]).includes(cls);
}

/** Class-level universal groups (LAN, tape across hw types). Tape stays LPAR elsewhere. */
export function isClassGroupMode(cls: string) {
  return (!isClassLPAR(cls) || cls === ClassKey.TAPE) && cls !== ClassKey.SAN;
}

export function isClassSTOR(cls: string) {
  return (STOR as readonly string[]).includes(cls);
}

export function isClassNetwork(cls: string) {
  return cls === ClassKey.SAN || cls === ClassKey.LAN;
}

/** Classes routed under /:class/type/:segment (SAN, LAN, Tape). */
export function isClassTypeNav(cls: string) {
  return cls === ClassKey.SAN || cls === ClassKey.LAN || cls === ClassKey.TAPE;
}